import Vue from "vue";
import App from "./App.vue";
import router from './router';
import GridManager from 'gridmanager-vue'
import 'gridmanager-vue/css/gm-vue.css'

Vue.use(GridManager);

new Vue({
  render: h => h(App),
  router,
}).$mount("#app");
